import * as React from 'react';
import HealthPlanUserInitQuestionnaireForm from './HealthPlanUserInitQuestionnaireForm';
import apiClient from '../../../Services/ApiClient';
import { useEffect, useMemo, useState } from 'react';
import OverlayLoading from '../../../Components/OverlayLoading';
import {
	useLazyQuestionnaireIdQuery,
	useQuestionnaireIdQuery,
} from '../../../graphql/graphql';
// @ts-ignore
import styles from './HealthPlanUserInitQuestionnaire.module.scss';
import ScrollContainer from '../../Base/Components/ScrollContainer';

interface HealthPlanUserInitQuestionnaireProps {
	patientId: string;
	onSuccess?: (data: { questionnaireResultId: string }) => void;
	setIsLoading: (isLoading: boolean) => void;
	readOnly?: boolean;
}

const HealthPlanUserInitQuestionnaire: React.FC<
	HealthPlanUserInitQuestionnaireProps
> = props => {
	const { patientId, onSuccess, setIsLoading, readOnly } = props;
	const { data, isLoading } = useQuestionnaireIdQuery({
		code: 'latamDiabetesEntryQuestionnaireDoctor',
	});


	const questionnaireId: string | undefined = useMemo(() => {
		return data?.questionnaire?.id;
	}, [data]);

	useEffect(() => {
		setIsLoading(isLoading);
	}, [isLoading]);

	const handleSave = async (values: { [key: string]: string }) => {
		setIsLoading(true);

		if (questionnaireId) {
			const questionnaireTree = (
				await apiClient.get('questionnaire/' + questionnaireId + '/tree')
			)?.data;
			const answers: any = {};

			interface TreeItem {
				id: string;
				type: string;
				children: [TreeItem];
			}

			const recursiveParseAnswersFromTree = (
				items: [TreeItem],
				parent: TreeItem | null = null,
			) => {
				for (const item of items) {
					if (item.type === 'answer') {
						answers[item.id] = {
							answer: item,
							question: parent,
						};
					}
					if (item?.children?.length) {
						recursiveParseAnswersFromTree(item.children, item);
					}
				}
			};

			if (questionnaireTree) {
				recursiveParseAnswersFromTree(questionnaireTree);

				const resultItems: {
					[key: string]: {
						questionId: string;
						answers: { id: string; value: any }[];
					};
				} = {};

				for (const answerKey of Object.keys(answers)) {
					const answerItem = answers[answerKey];
					const q = answerItem.question || null;
					const a = answerItem.answer || null;
					if (q) {
						if (typeof resultItems[q.id] === 'undefined') {
							resultItems[q.id] = {
								questionId: q.id,
								answers: [],
							};
						}

						if (
							typeof values[a.key] !== 'undefined' ||
							typeof q.key !== 'undefined'
						) {
							if (
								typeof values[a.key || q.key] !== 'undefined' &&
								values[a.key || q.key] !== null
							) {
								resultItems[q.id].answers.push({
									id: a.id,
									value: values[a.key || q.key],
								});
							}
						}
					}
				}

				const {
					data: { questionnaireResultId: questionnaireResultId },
				} = await apiClient.post(
					'/user/' +
						patientId +
						'/questionnaire/' +
						questionnaireId +
						'/result/',
					{
						questionnaireResultItems: Object.values(resultItems),
					},
				);

				console.log({ questionnaireResultId });

				onSuccess &&
					onSuccess({
						questionnaireResultId,
					});
			} else {
				setIsLoading(false);
			}
		}
	};

	return (
		<ScrollContainer>
			<div className={styles.wrapper}>
				<HealthPlanUserInitQuestionnaireForm
					onSubmit={handleSave}
					userId={patientId}
					readOnly={readOnly}
				/>
			</div>
		</ScrollContainer>
	);
};

export default HealthPlanUserInitQuestionnaire;
